module.exports = __webpack_public_path__ + "assets/images/3bc1fbf1ab91c3500a49bfd40031f39f.png";